import PointsModel from "../Points/PointsModel";
import TiersModel from "../Tiers/TiersModel";
import BadgesModel from "../Badges/BadgesModel";

export default class RewardsModel {
    public points: PointsModel = null;
    public tiers: TiersModel[] = null;
    public badges: BadgesModel = null;
}